import { VisitsService } from './../../_services/visits.service';
import { Component, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { Observable, BehaviorSubject } from 'rxjs';
import { BreakpointState, Breakpoints, BreakpointObserver } from '@angular/cdk/layout';
import { VisitsDataSource } from './visits.datasource';
import { MatDialog, MatPaginator,MatSort, MatSelect } from '@angular/material';
import { VisitsEditComponent } from '../visits-edit/visits-edit.component';
import { VisitsNewComponent } from '../visits-new/visits-new.component';
import { tap } from 'rxjs/operators';
import { Customer } from './../../_models/customer';
import { UserService } from './../../_services/user.service';
import { User } from './../../_models/user';
import { CustomerService } from './../../_services/customers.service';

@Component({
  selector: 'app-visits-view',
  templateUrl: './visits-view.component.html',
  styleUrls: ['./visits-view.component.css']
})
export class VisitsViewComponent implements OnInit, AfterViewInit {

  isExtraSmall: Observable<BreakpointState> = this.breakpointObserver.observe(Breakpoints.XSmall);
  displayedColumns: string[] = ['id', 'taskType', 'date', 'duration', 'customer', 'engineer', 'status'];
  dataSource: VisitsDataSource;
  pageSize = 20;
  defaultUserImg = "data:image/png;base64,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";


  customers: Observable<Customer[]>;
  engineers: Observable<User[]>;
  taskTypes = [{'id': 1, 'name': 'Visit'}, {'id': 2, 'name': 'Maintenance'}];
  filtType:number = 0;
  filtCustomer:number = 0;
  filtEngineer:number = 0;


  constructor(
    private breakpointObserver: BreakpointObserver,
    private service: VisitsService,
    public dialog: MatDialog,
    private customerService: CustomerService,
    private usersService: UserService,
  ) { }

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  ngOnInit() {
    this.dataSource = new VisitsDataSource(this.service);
    this.dataSource.load(0, this.pageSize);

    // Load Customers to dropdown
    this.customers = this.customerService.getAll('active=true');
    this.customers.subscribe();

    // Load Engineers to dropdown
    this.engineers = this.usersService.getAll();
    this.engineers.subscribe();
  }

  ngAfterViewInit(): void {
    this.paginator.page
      .pipe(
        tap(() => this.loadVisitsPage())
      )
      .subscribe();

      this.sort.sortChange
      .pipe(
        tap(() => this.loadVisitsPage())
      )
      .subscribe();
  }


  loadVisitsPage() {
    this.dataSource.load(this.paginator.pageIndex, this.paginator.pageSize,this.sort.active,this.sort.direction,this.filtType,this.filtCustomer,this.filtEngineer);
  }

  // Open the Edit Form dialog
  onRowEditClick(row) {
    const dialogRef = this.dialog.open(VisitsEditComponent, {
      width: '700px',
      height: '800px',
      maxWidth: '100vw',
      maxHeight: '100vh',
      data: {
        id: row.id,
        dataSource: this.dataSource
      }
    });

    const smallDialogSubscription = this.isExtraSmall.subscribe(result => {
      if (result.matches) {
        dialogRef.updateSize('100%', '100%');
      } else {
        dialogRef.updateSize('700px', '800px');
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      smallDialogSubscription.unsubscribe();
    });
  }

  // Opens the Add Page
  onAddClick() {
    const dialogRef = this.dialog.open(VisitsNewComponent, {
      width: '700px',
      height: '730px',
      maxWidth: '100vw',
      maxHeight: '100vh',
      // hasBackdrop: false,
      disableClose: true,
      data: {
        dataSource: this.dataSource,
        pageSize: this.pageSize,
        pageIndex: this.paginator.pageIndex
      }
    });

    const smallDialogSubscription = this.isExtraSmall.subscribe(result => {
      if (result.matches) {
        dialogRef.updateSize('100%', '100%');
      } else {
        dialogRef.updateSize('700px', '730px');
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      smallDialogSubscription.unsubscribe();
    });
  }

  onClearSearch(){
    this.filtType = 0;
    this.filtCustomer = 0;
    this.filtEngineer = 0;
    this.loadVisitsPage();
  }

  onSearchClick(){
    this.loadVisitsPage();
  }
}
